import type { ObservationModel } from '@ctw/shared/api/fhir/models/observation';
import { ContentCard } from '@ctw/shared/components/containers/content-card';
import { DefinitionList } from '@ctw/shared/components/definition-list';
import { ResponsiveSourceDocumentLink } from '@ctw/shared/content/CCDA/responsive-source-document-link';
import type { CTWRequestContext } from '@ctw/shared/context/ctw-context';
import type { UseResourceDrawerOpenDrawerArgs } from '@ctw/shared/context/resource-drawer-context';
import { useUnitSystemPreference } from '@ctw/shared/hooks/use-unit-system-preference';

interface ObservationDetailsProps {
  model: ObservationModel;
  requestContext: CTWRequestContext;
}

const ObservationDetails = ({ model, requestContext }: ObservationDetailsProps) => {
  const { unitSystem } = useUnitSystemPreference();
  const builderId = requestContext.builderId ?? '';
  return (
    <ContentCard
      variant="focal"
      title="Details"
      content={{
        header: <ResponsiveSourceDocumentLink model={model} />,
      }}
    >
      <DefinitionList
        items={[
          { label: 'Value', value: model.getValueWithUnits(unitSystem) },
          { label: 'Reference Range', value: model.getReferenceRange(unitSystem) },
          { label: 'Effective Date', value: model.dateDisplay },
          { label: 'Data Source', value: model.getDataSourceDisplay(builderId) },
        ]}
      />
    </ContentCard>
  );
};

export const observationDrawerAction: UseResourceDrawerOpenDrawerArgs<'Observation'>['action'] = ({
  model,
  requestContext,
}) => ({
  label: 'Observation',
  title: model.title,
  content: {
    body: <ObservationDetails model={model} requestContext={requestContext} />,
  },
});
